"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeSplitHistoryIssues = void 0;
exports.mergeSplitHistoryIssues = [
    {
        error_version: "1",
        error_status: "WARNING",
        case_status: null,
        coding_status: {
            process_instance_status: "IN_PROGRESS",
            qa_status: null,
            is_chargeable: true,
            is_cancelled: false,
            hold_status: null,
            hold_comment: null
        },
        field: null,
        message_key: null,
        message: "New child case added.",
        source: "MERGE_SPLIT_HISTORY",
        code: null,
        invoice_guid: null,
        transaction_guid: null,
        case_id: 26596,
        case_uid: "ae095544-e4e5-430c-847a-ba11ee8d6b11",
        caserun_uid: "0583de85-3eef-495c-8373-b51521cbfb6d",
        related_case_uid: null,
        related_caserun_uid: null,
        merge_split_history: {
            function: "Merge Cases",
            parent_case_id: null,
            parent_case_uid: null,
            parent_caserun_uid: null,
            child_case_id: "23528",
            child_case_uid: "8d754910-7274-4b8b-a9de-96a959cbdbc2",
            child_caserun_uid: "01e00dce-7e27-4761-8d3a-23c3c9856df5"
        }
    },
    {
        error_version: "1",
        error_status: "WARNING",
        case_status: null,
        coding_status: {
            process_instance_status: "IN_PROGRESS",
            qa_status: null,
            is_chargeable: true,
            is_cancelled: false,
            hold_status: null,
            hold_comment: null
        },
        field: null,
        message_key: null,
        message: "New child case added.",
        source: "MERGE_SPLIT_HISTORY",
        code: null,
        invoice_guid: null,
        transaction_guid: null,
        case_id: 26596,
        case_uid: "ae095544-e4e5-430c-847a-ba11ee8d6b11",
        caserun_uid: "0583de85-3eef-495c-8373-b51521cbfb6d",
        related_case_uid: null,
        related_caserun_uid: null,
        merge_split_history: {
            function: "Merge Cases",
            parent_case_id: null,
            parent_case_uid: null,
            parent_caserun_uid: null,
            child_case_id: "26196",
            child_case_uid: "56ed5612-b7e2-4706-af18-c71a914ec21b",
            child_caserun_uid: "d973f16a-faf9-4b34-a4a0-b8bc201a0220"
        }
    }
];
//# sourceMappingURL=merge-split-history-errors.js.map